import React from "react";
import { Link } from "react-router-dom";
import CourseImage from "../../assets/images/course-img.jpg";
import { useSelector } from "react-redux";
import { Image } from "react-bootstrap";
import DummyAvatar from "../../assets/images/Profile-thumbnail-small.svg";

export default function TabFilterContentCourse({ data }) {
  let auth = useSelector((state) => state.auth);
  return (
    <>
      {data.length > 0 ? (
        data?.map((courseItem) => (
          <div className="col-12 mb-20" key={courseItem.id}>
            <article className="custum-course-card p-10 h-100">
              {courseItem?.decline_reason &&
                courseItem?.status === "declined" && (
                  <div className="alert alert-danger py-5 px-10">
                    {courseItem.decline_reason}
                  </div>
                )}
              {courseItem?.unpublish_reason &&
                courseItem?.status === "unpublished" && (
                  <div className="alert alert-danger py-5 px-10">
                    {courseItem?.unpublish_reason}
                  </div>
                )}
              <div className="mb-12">
                <div className="img-holder mb-12">
                  <Link
                    to={
                      auth.role === "Admin"
                        ? `/admin-course-detail?id=${courseItem.id}`
                        : `/instructor-course-detail?id=${courseItem.id}`
                    }
                    className="text-decoration-none d-block"
                  >
                    {/* {courseItem?.image_url !== null ? ( 
                        <img src={JSON.parse(courseItem?.image_url)?.[0].data} alt={"Course Image"} className="course-img img-fluid" />
                      ) : ( */}
                    {/* <img
                        src={CourseImage}
                        className="course-img img-fluid"
                        alt=""
                      /> */}
                    {/* )} */}
                    <Image
                      src={
                        process.env.REACT_APP_GALLERY_URL +
                        JSON.parse(courseItem?.image_urls)?.[0]
                      }
                      alt={"Instructor"}
                      className="course-img img-fluid"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = CourseImage;
                      }}
                    />
                  </Link>
                </div>
                <div className="course-fav-icon">
                  <i className="bi bi-heart"></i>
                </div>
              </div>
              <div className="course-badge px-11 py-3 mb-10 d-inline-block">
                {courseItem?.Category?.name}
              </div>
              <Link
                to={
                  auth.role === "Admin"
                    ? `/admin-course-detail?id=${courseItem.id}`
                    : `/instructor-course-detail?id=${courseItem.id}`
                }
              >
                <h5 className="ah-text-md text-black fw-bold text-capitalize mb-12">
                  {courseItem?.title}
                </h5>
              </Link>

              <div className="inrol-students d-flex align-items-center">
                <div className="d-flex align-items-center ms-5">
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.8272 2.81944L7.42326 0.684799C7.31371 0.64828 7.19527 0.64828 7.08572 0.684799L0.681785 2.81944C0.575523 2.85487 0.483101 2.92283 0.417612 3.0137C0.352123 3.10457 0.316886 3.21374 0.316895 3.32575V8.66236C0.316895 8.8039 0.373119 8.93964 0.4732 9.03972C0.573281 9.1398 0.70902 9.19602 0.850555 9.19602C0.992091 9.19602 1.12783 9.1398 1.22791 9.03972C1.32799 8.93964 1.38422 8.8039 1.38422 8.66236V4.06621L3.62492 4.81267C3.0296 5.77446 2.84029 6.93319 3.09856 8.03445C3.35683 9.1357 4.04157 10.0894 5.00244 10.6863C3.8017 11.1572 2.76373 12.0091 2.0046 13.1738C1.96512 13.2325 1.93769 13.2984 1.92392 13.3678C1.91015 13.4372 1.9103 13.5086 1.92438 13.5779C1.93845 13.6472 1.96615 13.713 2.00589 13.7715C2.04562 13.83 2.09659 13.8801 2.15582 13.9187C2.21506 13.9573 2.28139 13.9838 2.35095 13.9966C2.42051 14.0094 2.49191 14.0082 2.56102 13.9931C2.63012 13.9781 2.69554 13.9494 2.75347 13.9089C2.8114 13.8683 2.86069 13.8166 2.89848 13.7568C3.90376 12.2145 5.4914 11.3307 7.25449 11.3307C9.01757 11.3307 10.6052 12.2145 11.6105 13.7568C11.6888 13.8732 11.8097 13.954 11.9471 13.9819C12.0845 14.0098 12.2274 13.9825 12.3448 13.9059C12.4622 13.8293 12.5448 13.7096 12.5747 13.5726C12.6045 13.4356 12.5793 13.2923 12.5044 13.1738C11.7452 12.0091 10.7033 11.1572 9.50653 10.6863C10.4665 10.0895 11.1506 9.13634 11.4088 8.0359C11.667 6.93545 11.4783 5.77751 10.884 4.816L13.8272 3.8354C13.9335 3.8 14.0259 3.73204 14.0914 3.64117C14.1569 3.5503 14.1922 3.44111 14.1922 3.32909C14.1922 3.21706 14.1569 3.10788 14.0914 3.01701C14.0259 2.92613 13.9335 2.85818 13.8272 2.82278V2.81944ZM10.4565 7.06138C10.4566 7.56759 10.3367 8.06663 10.1066 8.51754C9.87658 8.96845 9.54288 9.35839 9.13293 9.65536C8.72297 9.95234 8.24845 10.1479 7.74829 10.2259C7.24813 10.304 6.73659 10.2624 6.25564 10.1045C5.77468 9.94656 5.33802 9.67686 4.98148 9.31751C4.62494 8.95816 4.35869 8.5194 4.20455 8.03722C4.05042 7.55504 4.01281 7.04319 4.0948 6.54366C4.17679 6.04413 4.37606 5.57116 4.67624 5.16355L7.08572 5.96404C7.19527 6.00056 7.31371 6.00056 7.42326 5.96404L9.83274 5.16355C10.2381 5.71324 10.4567 6.37837 10.4565 7.06138Z"
                      fill="#F05203"
                    />
                  </svg>
                  <span className="ah-text-xs fw-semibold ms-3 text-black">
                    {courseItem?.enrolledStudentsCount}{" "}
                    {courseItem?.enrolledStudentsCount <= 1
                      ? "studnet"
                      : "students"}
                  </span>
                </div>
              </div>
            </article>
          </div>
        ))
      ) : (
        <div className="alert alert-info">No courses found</div>
      )}
    </>
  );
}
